import { layPuddle } from '../puddles';
import type { SpecialModule } from '../specials/types';

const UNDER_RADII = 0.6;
const SWING_RADII = 0.3;

export const puddle: SpecialModule = ({ state, tempo }, enemy, effect) => {
  if (effect.kind !== 'puddle' || !state.events.some((event) => event.type === 'bar')) {
    return;
  }
  const side = state.set.bar % 2 === 0 ? -1 : 1;
  layPuddle(state, {
    byId: enemy.id,
    x: enemy.x + side * SWING_RADII * enemy.radius,
    y: enemy.y + UNDER_RADII * enemy.radius,
    radius: effect.radius,
    bornTick: state.tick,
    driesTick: state.tick + effect.driesBars * tempo.ticksPerBar,
  });
};
